import IconNameEnum from "constants/IconNameEnum";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import BaseLabel from "../base-form/BaseLabel";

interface IProps {
    headerIcon?: IconNameEnum;
    headerTitle?: string;
    headerActions?: JSX.Element;
    headerActionsLeft?: JSX.Element;
    footerActionsRight?: JSX.Element;
    footerActionsLeft?: JSX.Element;
    headerClassName?: string;
    bodyClassName?: string;
    footerClassName?: string;
    headerFull?: boolean;
    bodyFull?: boolean;
    footerFull?: boolean;
    iconBadge?: string | number;
    isIE?: boolean;
    isSafari?: boolean;
    fullWidthActions?: boolean;
    headerIconClassName?: string;
    headerSubtitle?: string;
}

interface IState {
    windowWidth: number;
    windowHeight: number;
}

class BaseCard extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = { windowWidth: 0, windowHeight: 0 };
    }

    async componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        });
    };

    public render(): JSX.Element {
        const {
            headerIcon,
            headerTitle,
            headerActions,
            headerActionsLeft,
            footerActionsRight,
            footerActionsLeft,
            headerClassName,
            bodyClassName,
            footerClassName,
            headerFull,
            bodyFull,
            footerFull,
            iconBadge,
            fullWidthActions,
            headerIconClassName,
            headerSubtitle,
        } = this.props;

        const { windowWidth } = this.state;

        return (
            <Card className="ccq-shadow h-100">
                {headerTitle || headerIcon || headerActions ? (
                    <Card.Header
                        className={[
                            "bg-white",
                            headerActions ? "py-2" : "py-3",
                            headerFull ? "px-3" : "px-4",
                            headerClassName,
                        ].join(" ")}
                    >
                        <Row>
                            <Col
                                sm={headerActionsLeft ? 4 : "auto"}
                                className={`align-self-center ${headerActionsLeft ? "mb-2" : ""}`}
                            >
                                <BaseLabel
                                    badge={iconBadge}
                                    icon={headerIcon}
                                    label={headerTitle}
                                    labelClassName="h5 font-weight-bold"
                                    iconClassName={headerIconClassName && headerIconClassName}
                                />
                                {headerSubtitle && <BaseLabel label={headerSubtitle} labelClassName="step-subtitle" />}
                            </Col>
                            {headerActionsLeft && (
                                <Col sm={fullWidthActions || windowWidth < 1600 ? 12 : 8} className="align-self-center">
                                    {headerActionsLeft}
                                </Col>
                            )}
                            {headerActions && <Col className="text-right">{headerActions}</Col>}
                        </Row>
                    </Card.Header>
                ) : null}
                <Card.Body className={[bodyFull ? "p-0" : "pt-4 pb-4 px-4", bodyClassName].join(" ")}>
                    {this.props.children}
                </Card.Body>
                {footerActionsRight || footerActionsLeft ? (
                    <Card.Footer className={["bg-white py-2", footerFull ? "px-3" : "px-4", footerClassName].join(" ")}>
                        <Row>
                            {footerActionsLeft && (
                                <Col className="d-flex justify-content-between ">{footerActionsLeft}</Col>
                            )}
                            {footerActionsRight && (
                                <Col className="d-flex justify-content-end">{footerActionsRight}</Col>
                            )}
                        </Row>
                    </Card.Footer>
                ) : null}
            </Card>
        );
    }
}

export { BaseCard as Unconnected };
export default BaseCard;
